/**
 * FastAPI returns `detail` as a string for handled errors but as an array of
 * `{loc, msg}` objects for 422 validation errors. Turn either into a sentence.
 */
export function apiErrorMessage(body: unknown, fallback: string): string {
  const detail = (body as { detail?: unknown } | null | undefined)?.detail
  if (typeof detail === 'string' && detail.trim()) return detail
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (d && typeof (d as { msg?: unknown }).msg === 'string' ? (d as { msg: string }).msg : null))
      .filter((m): m is string => m !== null)
      .map((m) => m.replace(/^Value error, /, ''))
    if (msgs.length) return msgs.join(' ')
  }
  return fallback
}
